import React from "react"
import { BaseVisualizationConfigureModal } from "../../../Modals/BaseVisualizationConfigureModal"
import { MobergCheckbox, MobergColumn, MobergDropdown, MobergInputLabel, MobergNumberInput, MobergRow } from "../../../../../../../../Moberg"
import { CPPOPT_WINDOW_TIME_PRESETS } from "../../../../../../../../Managers/VisualizationManager/Viewport/Components/XAxis"
import { useEditWindow } from "../../../Modals/useEditWindow"
import { MAPOptPlotJSON } from "../../../../Types/MAPOptPlot"
import { mapOptPlotConfigsAtom } from "../../../../Atoms/MAPOpt"
import { validateCOxThreshold } from "../validation"
import { useTraceOptions } from "../../../Modals/EditAnalysis/useTraceOptions"
import { Analytic } from "../../../../Types/AnalysisDetails"
import { equalsTraceOptionOrString } from "../../../../utils"

type MAPOptPlotConfigureModalProps = {
	windowId: string
	layoutId: string
}

export const MAPOptPlotConfigureModal = (props: MAPOptPlotConfigureModalProps) => {
	const atom = mapOptPlotConfigsAtom({windowId: props.windowId, layoutId: props.layoutId})
	const traceOptions = useTraceOptions()
	const { editedConfig, saveChanges, updateProperty } = useEditWindow<MAPOptPlotJSON>({ recoilState: atom, windowId: props.windowId, layoutId: props.layoutId })
    
	return (
		<BaseVisualizationConfigureModal layoutId={props.layoutId} windowId={props.windowId} title={"Configure MAPOpt"} saveChanges={saveChanges}>
			<div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }}>
				<MobergColumn gap="32px" verticalAlign="center" expand={true}>
					<MobergColumn gap="32px">
						<MobergColumn expand={false} gap="8px">
							<MobergInputLabel text={"Initial window size"} />
							<MobergDropdown
								selectedValue={editedConfig?.viewDuration}
								onChange={value => updateProperty("viewDuration", parseInt(value as string))}
								options={CPPOPT_WINDOW_TIME_PRESETS
									.filter(preset => preset.label !== "Page Size")
									.map(preset => ({ label: preset.label, value: preset.time }))}
							/>
						</MobergColumn>

						<MobergColumn expand={false} gap="8px">
							<MobergInputLabel text={"ABP modality"} />
							<MobergDropdown
								selectedValue={editedConfig?.abpModality}
								onChange={option => updateProperty("abpModality", option.rawDataKey)}
								options={traceOptions}
								equals={equalsTraceOptionOrString}
							/>
						</MobergColumn>

						<MobergRow gap="32px">
							<MobergColumn gap="8px">
								<MobergInputLabel text={"StO2 (left)"} />

								<MobergDropdown
									options={traceOptions}
									onChange={option => updateProperty("stO2Left", option.rawDataKey)}
									selectedValue={editedConfig?.stO2Left}
									equals={equalsTraceOptionOrString}
								/>
							</MobergColumn>

							<MobergColumn gap="8px">
								<MobergInputLabel text={"Enabled"} />
								<MobergCheckbox isChecked={editedConfig?.enableLeft} onChange={newValue => updateProperty("enableLeft", newValue)} />
							</MobergColumn>
						</MobergRow>

						<MobergRow gap="32px">
							<MobergColumn gap="8px">
								<MobergInputLabel text={"StO2 (right)"} />

								<MobergDropdown
									options={traceOptions}
									onChange={option => updateProperty("stO2Right", option.rawDataKey)}
									selectedValue={editedConfig?.stO2Right}
									equals={equalsTraceOptionOrString}
								/>
							</MobergColumn>

							<MobergColumn gap="8px">
								<MobergInputLabel text={"Enabled"} />
								<MobergCheckbox isChecked={editedConfig?.enableRight} onChange={newValue => updateProperty("enableRight", newValue)} />
							</MobergColumn>
						</MobergRow>

						<MobergColumn expand={false} gap="8px">
							<MobergInputLabel text={"COx threshold of autoregulation"} />
							<MobergNumberInput
								defaultValue={0.3}
								validationFunction={validateCOxThreshold}
								value={editedConfig?.coxThreshold}
								onChange={threshold => updateProperty("coxThreshold", threshold)}
							/>

						</MobergColumn>
							<MobergColumn expand={false} gap="8px">
							<MobergInputLabel text={"MAPopt Algorithm"} />
							<MobergDropdown
								selectedValue={editedConfig?.mapoptAlgorithm}
								onChange={modality => updateProperty("mapoptAlgorithm", modality)}
								options={[
									{label: "Single-window", value: Analytic.MAPOpt},
									{label: "Multi-window", value: Analytic.MAPOpt_FLEX},
								]}
							/>
						</MobergColumn>

						</MobergColumn>
							<MobergColumn expand={false} gap="8px">
							<MobergInputLabel text={"Autoscale"} />
							<MobergDropdown
								selectedValue={editedConfig?.autoScale ?? false}
								onChange={autoScale => updateProperty("autoScale", autoScale)}
								options={[
									{label: "Yes", value: true},
									{label: "No", value: false},
								]}
							/>
						</MobergColumn>

				</MobergColumn>
			</div>
		</BaseVisualizationConfigureModal>
	)
}
